import { IBody } from '@makyoapp/makyo-sdk/models/AppBuilder'

export interface DesignBlockConfig {
  body: IBody[]
  bodySettings: Record<string, any>
}

export const DESIGN_BLOCK_MAP = {
  // DESIGN BLOCKS AREA

  // Basic Layouts
  ['basic-50-50']: '/templates/design-blocks/5050.json',
  ['basic-70-30']: '/templates/design-blocks/7030.json',
  ['basic-30-70']: '/templates/design-blocks/3070.json',
  ['basic-75-25']: '/templates/design-blocks/7525.json',
  ['basic-25-75']: '/templates/design-blocks/2575.json',
  ['basic-33-33-33']: '/templates/design-blocks/33.json',
  ['basic-25-25-25-25']: '/templates/design-blocks/25.json',

  // Complex Layouts
  ['complex-100-50-50']: '/templates/design-blocks/1005050.json',
  ['complex-100-33-33-33']: '/templates/design-blocks/10033.json',
  ['complex-100-60-40']: '/templates/design-blocks/1006040.json',
  ['complex-100-40-60']: '/templates/design-blocks/1004060.json',
  ['complex-100-25-75']: '/templates/design-blocks/1002575.json',
  ['complex-100-75-25']: '/templates/design-blocks/1007525.json',

  // Hero Layouts
  ['hero-1']: '/templates/design-blocks/hero-1.json',
  ['hero-2']: '/templates/design-blocks/hero-2.json',
  ['hero-3']: '/templates/design-blocks/hero-3.json',
  ['hero-4']: '/templates/design-blocks/hero-4.json',
  ['hero-5']: '/templates/design-blocks/hero-5.json',
  ['hero-6']: '/templates/design-blocks/hero-6.json',
  ['hero-7']: '/templates/design-blocks/hero-7.json',
  ['hero-8']: '/templates/design-blocks/hero-8.json',
  ['hero-9']: '/templates/design-blocks/hero-9.json',
  ['hero-10']: '/templates/design-blocks/hero-10.json',
  ['hero-11']: '/templates/design-blocks/hero-11.json',
  ['hero-12']: '/templates/design-blocks/hero-12.json',
  ['hero-13']: '/templates/design-blocks/hero-13.json',

  // Profile Layouts
  ['profile-1']: '/templates/design-blocks/profile1.json',
  ['profile-2']: '/templates/design-blocks/profile2.json',

  // CTA Layouts
  ['cta-1']: '/templates/design-blocks/cta1.json',
  ['cta-2']: '/templates/design-blocks/cta2.json',
  ['cta-3']: '/templates/design-blocks/cta3.json',
  ['cta-4']: '/templates/design-blocks/cta4.json',
  ['cta-5']: '/templates/design-blocks/cta5.json',
  ['cta-6']: '/templates/design-blocks/cta6.json',
  ['cta-7']: '/templates/design-blocks/cta7.json',
  ['cta-8']: '/templates/design-blocks/cta8.json',

  // Contact Layouts
  ['contact1']: '/templates/design-blocks/contact-1.json',
  ['contact2']: '/templates/design-blocks/contact-2.json',
  ['contact3']: '/templates/design-blocks/contact-3.json',
  ['contact4']: '/templates/design-blocks/contact-4.json',
  ['contact5']: '/templates/design-blocks/contact-5.json',
  ['contact6']: '/templates/design-blocks/contact-6.json',

  // Team Layouts
  ['team1']: '/templates/design-blocks/team1.json',
  ['team2']: '/templates/design-blocks/team2.json',
  ['team3']: '/templates/design-blocks/team3.json',
  ['team4']: '/templates/design-blocks/team4.json',
  ['team5']: '/templates/design-blocks/team5.json',
  ['team6']: '/templates/design-blocks/team6.json',

  // Buttons
  ['2-button']: '/templates/design-blocks/button2.json',

  // Service
  ['service1']: '/templates/design-blocks/service1.json',
  ['service2']: '/templates/design-blocks/service2.json',

  // Dashboard
  ['dashboard1']: '/templates/design-blocks/dashboard1.json',
  ['dashboard2']: '/templates/design-blocks/dashboard2.json',

  // PAGES AREA

  // Dashboard Page
  ['page-dashboard1']: '/templates/pages/dashboard1.json',
} as const

export type DesignBlockKey = keyof typeof DESIGN_BLOCK_MAP
